import type { Partner, WebsiteBanner } from "@cabocheck/shared/src/client/generated";
import { Link, useMatches } from "react-router";
import { useTranslation } from "react-i18next";

// Function to calculate text color based on background color for good contrast
function getContrastTextColor(backgroundColor: string): string {
  // Remove # if present
  const hex = backgroundColor.replace("#", "");

  // Convert to RGB
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Calculate luminance using relative luminance formula
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return white for dark backgrounds, black for light backgrounds
  return luminance > 0.5 ? "#000000" : "#FFFFFF";
}

export function Banner() {
  const { t } = useTranslation();

  return null;

  return (
    <Link
      target="_blank"
      to="https://calendly.com/cabocheck"
      className="block space-x-1 bg-blue-550 p-4 text-center text-sm text-white sm:text-base print:hidden"
      rel="noreferrer"
    >
      <b>{t("Wir sind auf der Expopharm 2024")}</b>
      <span className="block sm:inline">
        <span className="hidden sm:inline">-</span> {t("Halle B5  / Stand  D51")}
      </span>
      <span className="block sm:inline">
        {t("Jetzt Termin mit uns buchen und ein kostenloses Tagesticket erhalten.")}
      </span>
    </Link>
  );
}

export function PartnerBanner({ banner }: { banner?: WebsiteBanner | null }) {
  if (!banner) {
    return null;
  }

  const backgroundColor = banner.background_color || "#6B7280";
  const textColor = getContrastTextColor(backgroundColor);

  const bannerContent = (
    <div
      className="block space-x-1 p-4 text-center text-sm sm:text-base print:hidden"
      style={{
        backgroundColor: backgroundColor,
        color: textColor,
      }}
    >
      <p>{banner.content}</p>
    </div>
  );

  // If banner has a URL, wrap in a link
  if (banner.url) {
    return (
      <Link to={banner.url} target="_blank" rel="noreferrer" className="block">
        {bannerContent}
      </Link>
    );
  }

  return bannerContent;
}

export function InvoiceReminderBanner({ partner }: { partner: Partner }) {
  const { t } = useTranslation();

  const matches = useMatches();
  const last_match = matches.at(-1);

  const show_invoice_reminder =
    partner &&
    partner.last_open_partner_invoice_approved_date &&
    new Date(partner.last_open_partner_invoice_approved_date * 1000) < new Date(Date.now() - 1000 * 60 * 60 * 24 * 7) &&
    !last_match?.pathname.includes("reports/invoices");

  if (!show_invoice_reminder) {
    return null;
  }

  return (
    <Link
      to="/client/user_dashboard/reports/invoices"
      className="block space-x-1 bg-[#ff5a5a] p-4 text-center text-sm text-white sm:text-base print:hidden"
    >
      <span className="block sm:inline">
        {t("HINWEIS: Bitte prüfen Sie im Portal die Berichte -> Rechnungsübersicht.")}
      </span>
    </Link>
  );
}
